import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex);


export default new Vuex.Store({
    
    state: {
        isShowreelPlaying: false,
        preloderCount: 0,
        isCaseFullWidth: false,
        homeData: 'wop',
    },
    
    getters: {
        
    },
    
    // Mutations update State
    mutations: {
        toggleShowreel(state, value) {
            state.isShowreelPlaying = value
        },
        setCaseWidth(state, value) {
            state.isCaseFullWidth = value
        },
        setHomeData(state, value) {
            state.homeData = value
        }
    },
    
    // Entry point
    // - Actions triggers Mutations
    actions: {
        
        playShowreel(context) {
            if(context.state.isShowreelPlaying === false) {
                context.commit('toggleShowreel', true)
            }
        },
        
        stopShowreel(context) {
            if(context.state.isShowreelPlaying === true) {
                context.commit('toggleShowreel', false)
            }
        },
        
        caseFullWidth(context) {
            if(context.state.isCaseFullWidth === false) {
                context.commit('setCaseWidth', true)
            }
        },
        
        caseHalfWidth(context) {
            if(context.state.isCaseFullWidth === true) {
                context.commit('setCaseWidth', false)
            }
        },
        
        saveHomeData(context, data) {
            context.commit('setHomeData', data)
        },
        
    },
})
